export const translations = {
    MISSING_VALUE: 'Bitte eine Option auswählen',
};
